import * as React from "react";

import { SliderState } from ".";
import { SliderContext } from "./Slider";
import { ClassNames } from "../../_helpers/ClassNames";

type ControlProps = {
    goto: "next" | "previous" | number
};

const ControlUnwraped: React.SFC<ControlProps & SliderState> = (props) => {
    switch (props.goto) {
        case "next":
            return (
                <a
                    className={ClassNames('slider', 'control', 'next')}
                    onClick={props.goNext}
                >
                    {props.children}
                </a>);
        case "previous":
            return (
                <a
                    className={ClassNames('slider', 'control', 'previous')}
                    onClick={props.goPrevious}
                >
                    {props.children}
                </a>);
        default:
            return (
                <a
                    className={ClassNames('slider', 'control', 'go')}
                    onClick={() => props.go(props.goto as number)}
                >
                    {props.children}
                </a>);
    }
};

const Control: React.SFC<ControlProps> = (props: ControlProps) => {
    return (
        <SliderContext.Consumer>
            {(context: SliderState) => {
                const p = { ...context, ...props };
                return <ControlUnwraped {...p} />;
            }}
        </SliderContext.Consumer>);
}

export default Control;


// WEBPACK FOOTER //
// ./src/Components/Slider/Control.tsx